(function () {
  var CFG = window.EdenvaleFreeShipping;
  if (!CFG || !CFG.enabled) return;

  var STAGE_CLASSES = [
    'cart-free-shipping--stage-0',
    'cart-free-shipping--stage-1',
    'cart-free-shipping--stage-2',
    'cart-free-shipping--stage-3',
  ];
  var MARKERS = [
    'data-cart-free-shipping-update',
    'data-cart-free-shipping-message',
    'data-cart-free-shipping-text',
  ];
  var REMOVED_KEY = 'edenvaleGiftRemoved';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function sub(tpl, amount) {
    return (tpl || '').split('__AMT__').join(amount);
  }

  // Mirror of the Liquid model in snippets/cart-free-shipping-progress.liquid.
  function model(totalCents) {
    var giftActive = !!CFG.giftActive;
    var gc = CFG.giftCents || 0;
    var mc = CFG.metroCents || 0;
    var nc = CFG.nonMetroCents || 0;

    var empty = totalCents <= 0;
    var giftReached = totalCents >= gc;
    var metroReached = totalCents >= mc;
    var nonMetroReached = totalCents >= nc;

    var posGift = 15;
    var posMetro = giftActive ? 50 : 30;

    var fill = 0;
    if (!empty) {
      if (giftActive) {
        if (!giftReached) fill = (totalCents * posGift) / gc;
        else if (!metroReached) fill = posGift + ((totalCents - gc) * 35) / (mc - gc);
        else if (!nonMetroReached) fill = posMetro + ((totalCents - mc) * 35) / (nc - mc);
        else fill = 100;
      } else {
        if (!metroReached) fill = (totalCents * posMetro) / mc;
        else if (!nonMetroReached) fill = posMetro + ((totalCents - mc) * 50) / (nc - mc);
        else fill = 100;
      }
    }
    if (fill > 100) fill = 100;
    if (fill < 0) fill = 0;

    var stage = empty ? 0 : nonMetroReached ? 3 : 1;

    var message;
    if (empty) {
      message = CFG.strings.default;
    } else if (giftActive && !giftReached) {
      message = sub(CFG.strings.giftAway, formatMoney(gc - totalCents));
    } else if (!metroReached) {
      message = giftActive
        ? sub(CFG.strings.giftUnlockedMetroAway, formatMoney(mc - totalCents))
        : sub(CFG.strings.metroAway, formatMoney(mc - totalCents));
    } else if (!nonMetroReached) {
      message = sub(CFG.strings.nonMetroAway, formatMoney(nc - totalCents));
    } else {
      message = giftActive ? CFG.strings.allUnlocked : CFG.strings.unlocked;
    }

    return { stage: stage, fill: fill, message: message };
  }

  function applyToElement(el, totalCents, result) {
    var prevStage = parseInt(el.getAttribute('data-stage') || '0', 10);
    var stageChanged = prevStage !== result.stage;

    STAGE_CLASSES.forEach(function (c) { el.classList.remove(c); });
    el.classList.remove('cart-free-shipping--unlocked');
    el.classList.add('cart-free-shipping--stage-' + result.stage);
    if (result.stage === 3) el.classList.add('cart-free-shipping--unlocked');
    el.setAttribute('data-stage', String(result.stage));

    var msgEl = el.querySelector('.cart-free-shipping__message');
    if (msgEl) {
      msgEl.innerHTML = result.message;
      if (stageChanged) {
        el.classList.remove('cart-free-shipping--pulse');
        void el.offsetWidth; // force reflow so the animation restarts
        el.classList.add('cart-free-shipping--pulse');
      }
    }

    var railEl = el.querySelector('.cart-free-shipping__rail');
    if (railEl) {
      railEl.setAttribute('aria-valuenow', String(Math.round(result.fill)));
    }
    var fillEl = el.querySelector('.cart-free-shipping__fill');
    if (fillEl) {
      fillEl.style.setProperty('--fill', result.fill + '%');
    }

    el.querySelectorAll('.cart-free-shipping__stop[data-threshold]').forEach(function (stop) {
      var threshold = parseInt(stop.getAttribute('data-threshold') || '0', 10);
      if (totalCents >= threshold) stop.classList.add('is-reached');
      else stop.classList.remove('is-reached');
    });
  }

  function applyTotal(totalCents) {
    var result = model(totalCents);
    MARKERS.forEach(function (marker) {
      document.querySelectorAll('[' + marker + ']').forEach(function (el) {
        applyToElement(el, totalCents, result);
      });
    });
  }

  // ---------- Free gift auto-add / auto-remove (Phase 2) ----------
  // Inert unless a gift product is configured and in stock (CFG.giftActive + CFG.giftVariantId).
  var giftBusy = false;
  var prevGiftInCart = null; // unknown until the first cart read

  function cartHasGift(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(function (item) {
      return item.variant_id === CFG.giftVariantId || item.id === CFG.giftVariantId;
    });
  }

  // Section ids to re-render after a gift mutation — only those present on the page:
  // cart drawer, cart-page items + footer (dynamic section ids), header count, notification.
  function cartSectionsToRequest() {
    var ids = [];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    var items = document.getElementById('main-cart-items');
    if (items && items.dataset.id) ids.push(items.dataset.id);
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    if (document.getElementById('cart-notification-product')) ids.push('cart-notification-product');
    return ids;
  }

  function swapOuter(html, sourceSelector, targetSelector) {
    if (!html) return;
    var target = document.querySelector(targetSelector);
    if (!target) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = doc.querySelector(sourceSelector) || doc.body;
    if (source) target.innerHTML = source.innerHTML;
  }

  function replaceInner(html, selector, targetEl) {
    if (!html || !targetEl) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = doc.querySelector(selector);
    if (source) targetEl.innerHTML = source.innerHTML;
  }

  // Re-render every cart surface that is present, so an auto-added/removed gift shows up
  // live without a page refresh — cart drawer, cart-page items + footer, and header count.
  function applyCartSections(sections) {
    if (!sections) return;
    swapOuter(sections['cart-drawer'], '#CartDrawer', '#CartDrawer');
    swapOuter(sections['cart-icon-bubble'], '.shopify-section', '#cart-icon-bubble');
    var items = document.getElementById('main-cart-items');
    if (items && items.dataset.id) replaceInner(sections[items.dataset.id], '.js-contents', items.querySelector('.js-contents'));
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) replaceInner(sections[footer.dataset.id], '.js-contents', footer.querySelector('.js-contents'));
  }

  // Show the gift line in the open cart-notification popup, stacked on its own row BELOW the
  // product just added. #cart-notification-product is display:flex, so appending inside it would
  // place the gift beside the product — instead we insert a separate row as the next sibling.
  function appendGiftToNotification(sectionHtml, giftKey) {
    if (!sectionHtml || !giftKey) return;
    var container = document.getElementById('cart-notification-product');
    var notif = document.getElementById('cart-notification');
    if (!container || !notif || !notif.classList.contains('active')) return;
    var existing = document.getElementById('cart-free-shipping-gift-line');
    if (existing) existing.remove();
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var block = doc.getElementById('cart-notification-product-' + giftKey);
    if (!block) return;
    var row = document.createElement('div');
    row.id = 'cart-free-shipping-gift-line';
    row.className = 'cart-notification-product cart-free-shipping__gift-row';
    row.appendChild(block);
    container.parentNode.insertBefore(row, container.nextSibling);
  }

  function syncBarFromCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number') {
          applyTotal(cart.total_price);
          prevGiftInCart = cartHasGift(cart);
        }
      })
      .catch(function () { /* silent */ });
  }

  function addGift() {
    giftBusy = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: CFG.giftVariantId, quantity: 1, properties: { _free_gift: 'true' } }],
        sections: cartSectionsToRequest(),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (res) {
        if (res && res.sections) {
          applyCartSections(res.sections);
          var giftKey = res.items && res.items[0] && res.items[0].key;
          appendGiftToNotification(res.sections['cart-notification-product'], giftKey);
        }
        return syncBarFromCart();
      })
      .catch(function () { /* silent */ })
      .finally(function () { giftBusy = false; });
  }

  function removeGift() {
    giftBusy = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: String(CFG.giftVariantId),
        quantity: 0,
        sections: cartSectionsToRequest(),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        if (cart.sections) applyCartSections(cart.sections);
        if (typeof cart.total_price === 'number') {
          applyTotal(cart.total_price);
          prevGiftInCart = cartHasGift(cart);
        }
      })
      .catch(function () { /* silent */ })
      .finally(function () { giftBusy = false; });
  }

  function manageGift(cart) {
    if (!CFG.giftActive || !CFG.giftVariantId || giftBusy) return;
    if (!cart || typeof cart.total_price !== 'number') return;

    var total = cart.total_price;
    var giftInCart = cartHasGift(cart);
    var manuallyRemoved = sessionStorage.getItem(REMOVED_KEY) === '1';

    // A shopper removed the gift while still above the threshold: respect it, do not re-add.
    if (prevGiftInCart === true && !giftInCart && total >= CFG.giftCents) {
      sessionStorage.setItem(REMOVED_KEY, '1');
      manuallyRemoved = true;
    }

    if (total >= CFG.giftCents) {
      if (!giftInCart && !manuallyRemoved) {
        addGift();
        return; // refreshDrawerSections re-reads the cart; prevGiftInCart updates next pass
      }
    } else {
      // Below the threshold again: clear the manual flag and pull any lingering gift.
      if (manuallyRemoved) sessionStorage.removeItem(REMOVED_KEY);
      if (giftInCart) {
        removeGift();
        return;
      }
    }

    prevGiftInCart = giftInCart;
  }

  var fetchCounter = 0;
  function refreshFromCart() {
    var myId = ++fetchCounter;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (myId !== fetchCounter) return;
        if (cart && typeof cart.total_price === 'number') {
          applyTotal(cart.total_price);
          if (!cartHasGift(cart)) {
            var giftRow = document.getElementById('cart-free-shipping-gift-line');
            if (giftRow) giftRow.remove();
          }
          manageGift(cart);
        }
      })
      .catch(function () { /* silent */ });
  }

  function bindListener() {
    if (typeof subscribe !== 'function') return;
    subscribe('cart-update', function () { refreshFromCart(); });
    subscribe('quantity-update', function () { refreshFromCart(); });
  }

  // Expose for legacy callers that still expect these
  window.CART_FREE_SHIPPING_SECTION = 'cart-free-shipping-progress';
  window.getCartFreeShippingSectionKeys = function (sections) {
    if (!Array.isArray(sections)) return '';
    return sections.map(function (s) { return (s && (s.section || s.id)) || ''; }).filter(Boolean).join(',');
  };
  window.updateCartFreeShippingSections = function () { refreshFromCart(); };
  window.refreshCartFreeShipping = refreshFromCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindListener();
      refreshFromCart();
    });
  } else {
    bindListener();
    refreshFromCart();
  }
})();
